"use client";
import { useState } from "react";
import { toast } from "sonner";
import useSWR, { SWRConfiguration_Custom } from "swr";

/**
 * Component that checks for build version changes and reloads the page if a new version is detected.
 */
function BuildVersionValidator() {
    const [v, SetV] = useState<null | string>(null)

    useSWR("/api/version",
        {
            refreshInterval: 60 * 1000,
            refreshWhenHidden: true,
            "onSuccess": (buildID) => {
                if (v === null) {
                    SetV(buildID)
                } else if (v !== buildID) {
                    console.warn(`Website got updated. Reloading page...`);
                    toast.info("גרסה חדשה של האתר זמינה, טוען מחדש...")
                    window.location.reload();
                }
            },
            "onError": (err) => {
                console.error("Error fetching website version:", err);
            },
            "loadingTimeout": 10000,
            "revalidateOnFocus": true
        } as SWRConfiguration_Custom)

    return <></>
}

export default BuildVersionValidator